import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerXGroup } from "src/models/Customers/CustomerGroup.models";

interface CustomerXGroupState {
  customerXGroups: ICustomerXGroup[];
  customerXGroupToEdit: ICustomerXGroup | null;
}

const initialState: CustomerXGroupState = {
  customerXGroups: [],
  customerXGroupToEdit: null,
};

const customerXGroupSlice = createSlice({
  name: "CustomerXGroup",
  initialState,
  reducers: {
    setCustomerXGroupList: (
      state,
      action: PayloadAction<ICustomerXGroup[]>
    ) => {
      state.customerXGroups = action.payload;
    },
    concatListCustomerXGroup: (
      state: CustomerXGroupState,
      action: PayloadAction<ICustomerXGroup[]>
    ) => {
      state.customerXGroups = [...state.customerXGroups.concat(action.payload)];
    },
    setCustomerXGroupToEdit: (
      state,
      action: PayloadAction<ICustomerXGroup | null>
    ) => {
      state.customerXGroupToEdit = action.payload;
    },
    addCustomerXGroup: (state, action: PayloadAction<ICustomerXGroup>) => {
      state.customerXGroups.push(action.payload);
    },
    updateCustomerXGroup: (state, action: PayloadAction<ICustomerXGroup>) => {
      let itemIndex = state.customerXGroups.findIndex(
        item =>
          item.customerXCustomerGroupId ===
          action.payload.customerXCustomerGroupId
      );
      if (itemIndex !== -1) state.customerXGroups[itemIndex] = action.payload;
    },
    deleteCustomerXGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.customerXGroups.filter(
        item => item.customerXCustomerGroupId !== action.payload
      );
      state.customerXGroups = newArray;
    },
  },
});

export const {
  setCustomerXGroupList,
  concatListCustomerXGroup,
  setCustomerXGroupToEdit,
  addCustomerXGroup,
  updateCustomerXGroup,
  deleteCustomerXGroup,
} = customerXGroupSlice.actions;

export default customerXGroupSlice.reducer;
